module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/notify-button/notify-button.component.scss
// module id = ./src/app/shared/components/notify-button/notify-button.component.scss
// module chunks = main